import { dayjs } from '@tribeplatform/react-components/common/lib'
import { T } from '@tribeplatform/react-components/i18n'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'

import { useTrialStatus } from '../hooks/useTrialStatus.js'

export const TrialStatusAlert = () => {
  const { isTrialActive, trialEndDate } = useTrialStatus()

  if (isTrialActive && trialEndDate) {
    const duration = dayjs(trialEndDate).fromNow(true)
    return (
      <Alert status="info" rounded>
        <div className="space-y-0.5">
          <p className="font-medium">
            <T
              defaultMessage="Free trial active"
              id="Admin.Billing.PlanCards.TrialActive.Title"
            />
          </p>
          <p className="text-sm">
            <T
              defaultMessage="{duration} remaining"
              id="Admin.Billing.PlanCards.TrialActive.DurationRemaining"
              values={{ duration }}
            />
          </p>
        </div>
      </Alert>
    )
  }

  return (
    <Alert status="warning" rounded>
      <div className="space-y-0.5">
        <p className="font-medium">
          <T
            defaultMessage="Trial expired"
            id="Admin.Billing.PlanCards.TrialExpired.Title"
          />
        </p>
        <p className="text-sm">
          <T
            defaultMessage="Subscribe to keep your community live."
            id="Admin.Billing.PlanCards.TrialExpired.Subtitle"
          />
        </p>
      </div>
    </Alert>
  )
}
